import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../Layout/Loader";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import VerifyOtp from "../Auth/VerifyOtp";
import PrivateRoute from "./PrivateRoute";
import LandingPage from "../Landing/LandingPage";
import PrivacyPage from "../Landing/PrivacyPage";
import TermsPage from "../Landing/TermsPage";
import SupportPage from "../Landing/SupportPage";

// Redirect already-authenticated users away from login/verify-otp
const PublicOnlyRoute = () => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
    || localStorage.getItem("authenticated") === "true";
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

const Routers = () => (
  <BrowserRouter basename="/">
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public pages */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/support" element={<SupportPage />} />

        {/* Public-only routes (redirect to dashboard if logged in) */}
        <Route element={<PublicOnlyRoute />}>
          <Route path="/login" element={<Signin />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
        </Route>

        {/* Protected routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/*" element={<LayoutRoutes />} />
        </Route>
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default Routers;
